<section class="ut-dash-card" aria-labelledby="dashboardDevicesTitle">
  <h2 class="ut-dash-card__heading" id="dashboardDevicesTitle" tabindex="-1">My Devices</h2>
  @if (devices.length) {
    <div class="ut-dash-scroll">
      <!-- Takes focus when it scrolls; its name says what it is when it does (UT-3094). -->
      <ul class="ut-dash-scroll__list" utScrollFocus aria-labelledby="dashboardDevicesTitle">
        @for (device of devices; track $index) {
          <li class="ut-dash-device">
            <span class="ut-dash-icon" aria-hidden="true">
              <i class="material-icons {{ device.icon }}"></i>
            </span>
            <span class="ut-dash-device__text">
              <span class="ut-dash-device__name">{{ device.primary }}</span>
              <span class="ut-dash-device__detail">{{ device.secondary }}</span>
            </span>
          </li>
        }
      </ul>
    </div>
  }
  <a class="ut-dash-card__footer" [href]="testerAppUrl + '/account/my-profile/devices'">+ Add devices</a>
</section>
